<template>
  <div>
    <div slot="title">
      <h2>Reestablecer Contraseñas</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:30px;">
          <div class="col-3">
            <label for="">Búsqueda</label>
            <input type="text"
                   class="form-control"
                   placeholder="Nombre"
                   v-model="nombreBusqueda"
                   v-on:keyup.enter="buscarEvaluados" />
          </div>
          <div class="col-3">
            <label for="">No. de Nómina</label>
            <input type="text"
                   class="form-control"
                   placeholder="No. de Nómina"
                   v-model="numeroNominaBusqueda"
                   v-on:keyup.enter="buscarEvaluados" />
          </div>
          <div class="col-1">
            <input type="checkbox" v-model="filtroPuesto" />
          </div>
          <div class="col-2">
            <span class="label label-default">Tipo de Puesto</span>
          </div>
          <div class="col-2">
            <input type="button"
                   value="Buscar"
                   v-on:click="buscarEvaluados"
                   class="form-control" />
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-3"><hr /></div>
        </div>
        <div class="row">
          <div class="col-3"></div>
          <div class="col-3">
            <div class="alert alert-danger"
                 role="alert"
                 data-dismiss="alert"
                 aria-label="Close"
                 id="alertaNumeroNomina">
              Valor no válido
            </div>
          </div>
          <div class="col-1" v-show="filtroPuesto">
            <input type="checkbox" v-model="interinoBusqueda" />
          </div>
          <div class="col-2" v-show="filtroPuesto">
            <span class="label label-default">Interinato</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-1" v-show="filtroPuesto">
            <input type="checkbox" v-model="deBaseBusqueda" />
          </div>
          <div class="col-2" v-show="filtroPuesto">
            <span class="label label-default">Base</span>
          </div>
        </div>
        
        
        <div class="row">
          <div class="col-12"><hr /></div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-light table-hover"
                   id="tablaPersonal">
              <thead class="thead-dark">
                <tr>
                  <th>Número de Nómina</th>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>Usuario</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class="text-dark">
                <tr v-for="infoPersona in infoPersonas">
                  <td>{{ infoPersona.NumeroNomina }}</td>
                  <td>{{ infoPersona.NombreCompleto }}</td>
                  <td>{{ infoPersona.Puesto }} - {{infoPersona.Seccion}} - {{infoPersona.Departamento}}</td>
                  <td>{{ infoPersona.Usuario }}</td>
                  <td class="d-flex justify-content-around">
                    <i class="fa fa-key"
                       v-if="infoPersona.Usuario != 'N/D'" 
                       @click="pedirConfirmacion(infoPersona)"
                       title="Reestablecer Contraseña" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal fade"
             id="modalConfirmacion"
             tabindex="-1"
             role="dialog"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="tituloModalConfirmacion"></h5>
                <button type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <h6>
                  <span id="cuerpoModalConfirmacion"
                        class="col-form-label"></span>
                </h6>
              </div>
              <div class="modal-footer">
                <button type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal">
                  Cancelar
                </button>
                <button type="button"
                        class="btn btn-primary"
                        id="botonModalConfirmacion"
                        data-dismiss="modal">
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import Vue from "vue";
import store from "@/store/index";

export default {
  data() {
    return {
      enumeraciones,
      filtroPuesto: false, //Verifica que el filtro de tipo de contrato esté activado
      boton: "", //Almacena el botón presionado para la Activación/Desactivación
      bandera: true, //Identifica si la acción que se quiere realizar es activación o desactivación
      nombreBusqueda: "", //Filtro de busqueda de nombre
      numeroNominaBusqueda: "", //Filtro de busqueda de número de nómina
      interinoBusqueda: false, //Filtro de busqueda para personal interino
      deBaseBusqueda: false, //Filtro de busqueda para personal de base
      infoPersonas: [],
      botonDescargarReporte: false, // botón de descarga del reporte de usuarios
      comboAreaId: null,
      comboAreaNombre: null,
      PersonaId: null,
      datosLocales: [
        {
          Id: 0,
          key: "area",
          valor: { Id: -1, nombre: null }
        }
      ]
    };
  },
  components: {
    C001Area: catalogos.PJ.C001Area
  },
  methods: {   
    //busca a traves de axios el personal almacenado en base de datos
    buscarEvaluados: function(event) {
      if (this.numeroNominaBusqueda != "" && isNaN(this.numeroNominaBusqueda)) {
        $("#alertaNumeroNomina").show();
        return;
      }
      var peticion = {
        //Carga los valores para enviar la petición de busqueda
        esPrueba: false,
        nombreBusqueda: this.nombreBusqueda,
        numeroNominaBusqueda: parseInt(this.numeroNominaBusqueda, 10),
        tipoPuestoBusqueda: this.filtroPuesto,
        interinoBusqueda: this.interinoBusqueda,
        deBaseBusqueda: this.deBaseBusqueda,
        baneados: [],
        ObtenerUsuarioContrasena: true
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SISEVA.funcion.GetPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            $("#alertaNumeroNomina").hide();
            this.infoPersonas = response.data.InfoPersonas; //transifiere los datos necesarios
            
            this.mostrarTabla = true;
            this.$nextTick(() => {
              PaginarTabla("tablaPersonal", 10);
            });
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    
    pedirConfirmacion: function(infoPersona) {
      //Abre un modal que solicita confirmación al momento de desactivar o cancelar la desactivación de un usuario
      //Identifica si se quiere hacer una desactivacion o una cancelacion en base al tipo de boton
      this.PersonaId = infoPersona.PersonaId
     var nombre = infoPersona.NombreCompleto
      var mensaje =
        "¿Está seguro de reestablecer la contraseña de " +
        nombre + "("+infoPersona.Usuario+")"+
        "?";
      var titulo =
        "Confirmación de reestablecimiento de contraseña"; //Crea los mensajes del modal dependiendo de la acción a realizar
      $("#cuerpoModalConfirmacion").html(mensaje);
      $("#tituloModalConfirmacion").html(titulo);
      $("#modalConfirmacion").modal();
      $("#botonModalConfirmacion")
        .unbind("click")
        .click(this.ReestablecerContrasena); //Prepara las caracterisiticas de los elementos del modal
    },    
    ReestablecerContrasena: function() {
      //Obtiene el id de la persona a modificar
     var peticion = {
       esPrueba: false,
       PersonaId: this.PersonaId
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(api.conexion + api.SISEVA.funcion.ReestablecerContrasena, peticion)
        .then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta('Contraseña reestablecida correctamente.<br>Al ingresar al sistema se le solicitara cambiarla.<br>La contraseña provisional es: <h5><u>' + response.data.NuevaContrasena+"</u></h5>", null, null);
            
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          this.PersonaId = null;
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    
    getValorEntidad(respuestaHijo) {
      this.datosLocales[0].valor = {
        Id: parseInt(respuestaHijo.target.value),
        nombre:
          respuestaHijo.target.options[respuestaHijo.target.selectedIndex].text
      };
    }
  },
  mounted: function() {
    $("#alertaNumeroNomina").hide(); //Oculta la alerta de error en Número de Nómina (para busqueda) al montar el componente
    //this.buscarEvaluados();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/SISEVA/AdministracionCuentas/ReestablecerContrasenas.vue